import React from "react";
import styles from "./Note.module.css";

export default function Note({ children }: { children?: React.ReactNode }) {
  return <div className={styles.note}>{children}</div>;
}
